import CountUp from './CountUp'

export default function StatTile({
  label,
  value,
  note,
  suffix,
  decimals = 0,
}: {
  label: string
  value: number
  note?: string
  suffix?: string
  decimals?: number
}) {
  return (
    <div className="border border-rule px-4 py-5">
      <p className="text-caps text-[10px] text-muted">{label}</p>
      <p className="mt-2 font-serif text-[36px] leading-none tabular-nums">
        <CountUp value={value} decimals={decimals} />
        {suffix}
      </p>
      {note ? <p className="mt-2 text-xs text-muted">{note}</p> : null}
    </div>
  )
}
